import React from "react";
import {
  Box,
  Button,
  IconButton,
  TextField,
  Chip,
  Dialog,
  Divider,
  Typography,
  InputBase
} from "@mui/material";
import PropTypes from "prop-types";
import Collapse from "@mui/material/Collapse";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import Grid from "@mui/material/Grid";
import SaveAltIcon from "@mui/icons-material/SaveAlt";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import { tableCellClasses } from "@mui/material/TableCell";
import { styled } from "@mui/material/styles";
import EmployeeTrainingDetails from "./EmployeeTrainingDetails";
import EditEmployeeTraing from "./EditEmployeeTraing";
import { useState, useRef, useEffect, useLayoutEffect } from "react";
import useFetch from "../../../utils/useFetch";
import EmployeeView from "./EmployeeView";
import axios from "../../../utils/fvAxios";
import { ToastContainer, toast } from "react-toastify";
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Autocomplete } from '@mui/material'
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import { getGlobalClientId } from "../../../utils/Token";
import apiinfo from '../../../utils/base-uri.json';
import { useForm } from 'react-hook-form';
import OutlinedInput from '@mui/material/OutlinedInput';
import Nodata from '../../../pages/Nodata/Nodata';
import { CSVLink } from "react-csv";
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from "react-router-dom";
import ClearIcon from '@mui/icons-material/Clear';
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Pagination from '@mui/material/Pagination';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Paginator from "../../../toolkit/Paginator";
import GetfVDateFormate from "../../../utils/Genaricfunctions";
import debounce from 'lodash/debounce';




import { useTranslation } from "react-i18next";
import "../../../Localization/i18n";
import EmployeeSearch from "./EmployeeSearch";
import SearchSIngleDownload from "./SearchSIngleDownload";
import FilterSingleDownloadEmp from "./FilterSingleDownloadEmp";

const emptyGuid = "00000000-0000-0000-0000-000000000000";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#F9FAFB",
    color: "#667085",

  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

function Row(props) {

  const { row } = props;
  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);
  const [isMoodleEmployee, setisMoodleEmployee] = React.useState("");
  const [GetEmployeeCategories, setGetEmployeeCategories] = useState([]);
  const [userid, setUserid] = useState("");
  const [fvuserid, setFvUserid] = useState("");
  const [deleteEmployee, setDeleteEmployee] = useState([]);

  const headers = [
    { label: "Client Name", key: "client" },
    { label: "Vendor Name", key: "vendor" },
    { label: "Employee Name", key: "empName" },
    { label: "Course Name", key: "templateName" },
    { label: "Status", key: "quizResult" },
    { label: "Last Taken On", key: "quizDateStart" },
  ];


  function convertToCSV(data) {
    const header = headers.map(header => `"${header.label}"`).join(',');
    const rows = data.map(item =>
      headers.map(header => `"${item[header.key]}"`).join(',')
    );

    return [header, ...rows].join('\n');
  }
  // console.log(props?.closeCollapsed);
  useEffect(() => {
    if (props?.closeCollapsed) {

      setOpen(false)
    }
  }, []);
  const [openpop, setOpenpop] = React.useState(false);
  const [EmpId, setEmpId] = React.useState();
  const handleChange = (event) => {
    setAge(event.text);
  };
  const { t } = useTranslation();
  const handleClickOpenpop = (e) => {
    setEmpId(e)
    setOpenpop(true);
  };

  const handlePopClose = () => {
    setOpenpop(false);
  };

  const EDiThandle = (e) => {
    setGetEmployeeCategories(e);

    setOpen1(true);
  };
  const DeleteEmployee = async () => {
    setOpenpop(false)
    props?.setSpinners(true);
    axios
      .post(
        "Employee/DeleteEmployee?fvUserID=" +
        EmpId,
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        if (res?.data?.responseMessage == "Success") {
          toast.success(res?.data?.responseMessage, {
            position: "top-right",
            autoClose: 4000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          props?.setSpinners(false);
          setTimeout(() => {
            props?.setRefres(!props?.refres);
          }, 2000);

        } else {
          toast.error(res?.data.responseMessage, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }

      })
      .catch((err) => {
        console.log(err);
      });
  };
  const handleClose = () => {
    setOpen1(false);
  };
  const handleClickOpen1 = (e) => {
    setOpen2(true);
  };
  const handleClose1 = () => {
    setOpen2(false);
  };
  const [age, setAge] = React.useState("");

  // const handleClickOpen12 = (row) => {

  //   props?.setSpinners(true);

  //   axios
  //     .get("Employee/DownloadEmployeeTrainingSummary?clientId=10&vendorId=12&moodleUserId=12",

  //     )
  //     .then((res) => {
  //       if (res?.data.data == "Success") {

  //         props?.setSpinners(false);

  //       } else {
  //         props?.setSpinners(false);
  //         toast.error(res?.data?.responseMessage, {
  //           position: "top-right",
  //           autoClose: 5000,
  //           hideProgressBar: false,
  //           closeOnClick: true,
  //           pauseOnHover: true,
  //           draggable: true,
  //           progress: undefined,
  //           theme: "light",
  //         });
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  // };

  const [showPdf, setShowPdf] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [csvData, setCsvData] = useState(null);


  const handleFetchAndDownloadCSV1 = (ro) => {

    axios
      .post(
        "Employee/GetSpecificEmployeeQuizzes?VendorId=" + ro?.vendorid + "&EmployeeUserId=" + ro?.fvuserid
      )
      .then((res) => {
        if (res?.data) {
          setApiData(res?.data?.data);

        } else {
          // setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
        // setError("Error fetching API data");
      });
    if (ro && apiData?.length > 0) {
      const csvData = apiData?.reduce((acc, trainingSet) => {
        return acc.concat(
          trainingSet.map(training => ({
            client: training.clientname,
            vendor: ro.vendorname,
            empName: `${ro.firstname} ${ro.lastname}`,
            templateName: training.coursename,
            quizResult: training.quizstatus,
            quizDateStart: training.lastwatched,
          }))
        );
      }, []);

      const headers = [
        { label: "Client Name", key: "client" },
        { label: "Vendor Name", key: "vendor" },
        { label: "Employee Name", key: "empName" },
        { label: "Course Name", key: "templateName" },
        { label: "Status", key: "quizResult" },
        { label: "Last Taken On", key: "quizDateStart" },
      ];

      const header = headers.map(header => `"${header.label}"`).join(',');
      const rows = csvData.map(item =>
        headers.map(header => `"${item[header.key]}"`).join(',')
      );

      const csvContent = [header, ...rows].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'Employee training summary .csv';
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  const handleFetchAndDownloadCSV = (ro) => {


    if (ro && ro.tranings) {
      const csvData = ro.tranings.reduce((acc, training) => {
        return acc.concat({
          client: training.clientname,
          vendor: ro.vendorname,
          empName: `${ro.firstname} ${ro.lastname}`,
          templateName: training.coursename,
          quizResult: training.quizstatus,
          quizDateStart: training.lastwatched,
        });
      }, []);

      const headers = [
        { label: "Client Name", key: "client" },
        { label: "Vendor Name", key: "vendor" },
        { label: "Employee Name", key: "empName" },
        { label: "Course Name", key: "templateName" },
        { label: "Status", key: "quizResult" },
        { label: "Last Taken On", key: "quizDateStart" },
      ];

      const header = headers.map(header => `"${header.label}"`).join(',');
      const rows = csvData.map(item =>
        headers.map(header => `"${item[header.key]}"`).join(',')
      );

      const csvContent = [header, ...rows].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = url;
      a.download = 'Employee training summary .csv';
      a.click();
      URL.revokeObjectURL(url);
    }
  };

  return (
    <>

      <React.Fragment>
        <ToastContainer />
        <Dialog
          open={openpop}
          keepMounted
          onClose={handlePopClose}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle> {"Are you sure you want to delete the employee & associated trainings?"}</DialogTitle>
          <DialogContent>
            {/* <DialogContentText id="alert-dialog-slide-description">
            {t('VendorDetails.label9')}
          </DialogContentText> */}
          </DialogContent>
          <DialogActions>
            <Button onClick={handlePopClose}>{"Cancel"}</Button>
            <Button onClick={DeleteEmployee}>{t('VendorDetails.label8')}</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={open1}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <EditEmployeeTraing isMoodleEmployee={isMoodleEmployee}
            userid={userid} refe={props?.refres} setResh={props?.setRefres} fvuserid={fvuserid} spin={props?.spinners} setSpin={props?.setSpinner} userdetails={GetEmployeeCategories} close={handleClose} />
        </Dialog>
        <Dialog
          open={open2}
          onClose={handleClose1}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          sx={{
            "& .MuiDialog-container": {
              "& .MuiPaper-root": {
                width: "100%",
                maxWidth: "1050px",
              },
            },
          }}
        >
          <EmployeeView
            isMoodleEmployee={isMoodleEmployee}
            userid={userid}
            fvuserid={fvuserid}
            close={handleClose1}
          />
        </Dialog>
        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
          <TableCell style={{ width: "10px" }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
              sx={{ color: "#667085" }}
            >
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
          <TableCell component="th" scope="row" sx={{ color: "#667085" }}>
            <span style={{ fontWeight: open ? 600 : 500, fontSize: "14px" }}>{row?.vendorname}</span>
          </TableCell>
          <TableCell align="left" sx={{ color: "#667085", fontWeight: "bold", fontSize: "14px", fontWeight: open ? 600 : 500, fontSize: "14px", width: "150px" }}>
            {row?.firstname} {row?.lastname}
          </TableCell>
          <TableCell align="left" sx={{ color: "#667085", width: "131px", fontWeight: open ? 600 : 500, fontSize: "14px" }}>
            {row?.fvusername}
          </TableCell>
          <TableCell align="left" sx={{ color: "#667085", fontWeight: open ? 600 : 500, fontSize: "14px" }}>
            {row?.title}
          </TableCell>
          <TableCell align="left" sx={{ color: "#667085", fontWeight: open ? 600 : 500, fontSize: "14px" }}>
            {/* {row?.userid} */}{row?.documenttype ? row?.documenttype : "-"}
          </TableCell>
          <TableCell align="center" sx={{ color: "#667085", width: "150px", fontWeight: open ? 600 : 500, fontSize: "14px" }}>
            {row?.last4digitsofid}
          </TableCell>

          <TableCell align="center" sx={{ color: "#667085", width: "25px", fontWeight: open ? 600 : 500, fontSize: "14px" }}  >
            <div>

              {(props?.setTrue == true ? (<>
                {/* <SearchSIngleDownload ApiData={apiData} /> */}
                <SaveAltIcon sx={{ color: "#98A2B3", fontWeight: open ? 600 : 500, cursor: "pointer" }} onClick={() => handleFetchAndDownloadCSV1(row)} />

              </>) : (<>

                <SaveAltIcon sx={{ color: "#98A2B3", fontWeight: open ? 600 : 500, cursor: "pointer" }} onClick={() => handleFetchAndDownloadCSV(row)} />

              </>))}


            </div>
          </TableCell>


          <TableCell style={{ width: "2px", fontWeight: open ? 600 : 500, fontSize: "14px" }}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => {
                setisMoodleEmployee(row.isMoodleEmployee);
                handleClickOpen1(row.userid);
                setUserid(row.userid);
                setFvUserid(row.fvuserid)
              }}
            >
              <Tooltip title="Category Status History" placement="top" arrow>
                <ContentPasteIcon sx={{ color: "#98A2B3", fontWeight: open ? 600 : 500 }} />
              </Tooltip>
            </IconButton>
          </TableCell>
          <TableCell style={{ width: "2px", fontWeight: open ? 600 : 500, }} hidden={row.fvuserid == emptyGuid}>
            <IconButton onClick={() => {
              setisMoodleEmployee(row.isMoodleEmployee);
              EDiThandle(row);
              setUserid(row.userid);
              setFvUserid(row.fvuserid)
            }} aria-label="expand row" size="small">
              <Tooltip title="Edit Employee" placement="top" arrow>
                <EditRoundedIcon sx={{ color: "#98A2B3", fontWeight: open ? 600 : 500 }} /></Tooltip>
            </IconButton>
          </TableCell>
          <TableCell style={{ width: "2px", fontWeight: open ? 600 : 500 }} hidden={row.fvuserid == emptyGuid}>
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => handleClickOpenpop(row?.fvuserid)}
            >

              <Tooltip title="Delete" placement="top" arrow>
                <DeleteOutlineIcon sx={{ color: "#98A2B3", fontWeight: open ? 600 : 500 }} /></Tooltip>
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
            <Collapse in={open} timeout="auto" unmountOnExit>
              {props?.setTrue == true ? (<><EmployeeSearch row={row} openTabs={open} /></>) : (<>
                <EmployeeTrainingDetails row={row} refe={props?.refres} setResh={props?.setRefres} /></>)}
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    </>
  );
}

export default function EmployeeList() {
  const [EmailtemplateLists, setEmailtemplateLists] = useState([]);
  const [Count, setCount] = useState('');
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchInput, setSearchInput] = useState("");
  const [PqClients, setPqClients] = useState([]);
  const [selectValue1, setSelectValue1] = useState("0");
  const [refresh, setRefresh] = React.useState(false);
  const [initialLoadComplete, setInitialLoadComplete] = useState(false);
  const changeClients = (e) => {
    setSelectValue1(e);
    setClientID(e);
    setInitialLoadComplete(true)
    setSelectedVendor(null)
  }

  // useEffect(() => {
  //   axios.get("Prequalification/GetAllClients?getAll=true"
  //   ).then(resp => {
  //     setPqClients(resp?.data?.data);
  //   }).catch(err => {
  //     console.log(err)
  //   })
  // }, [setPqClients]);


  const [vendor, setVendor] = useState([]);
  const [client, setClient] = React.useState([]);
  const [error, setError] = useState(null);
  const [period, setPeriod] = React.useState([],);
  const [fincialdata, setFincialdata] = React.useState([])
  const [clientID, setClientID] = useState("");
  const [vendorID, setVendorID] = useState("");


  const [istrue, SetIstrue] = React.useState(false);
  const { register } = useForm();
  useEffect(() => {
    axios.get(apiinfo.Clients.GetAllClients + "getAll=true"
    ).then((res) => {
      if (res.data.responseCode === 100) {
        setClient([{ value: '0', text: 'Select' }, ...res.data.data])
        // getVendorsByClientAndFreeText('');
      }
      else {
        setError(res.data.responseMessage);
      }
    }).catch(err => {
      console.log(err)
    })

  }, []);

  const clientIDs = clientID; // Replace this with your client ID
  const getVendorsByClientAndFreeText = (searchValue) => {
    const searchQuery = searchValue; // Ensure searchQuery is empty if searchValue is null or undefined
    const SearchValue = searchQuery?.length >= 3 ? searchQuery : ""
    axios
      .get(
        "Vendor/GetVendorsByClient?clientId=" + clientID + "&freeText=" + SearchValue + "&pageNumber=1&pageSize=30"
      )
      .then((res) => {
        if (res.data.responseCode === 100) {
          setVendor(res.data.data);
        } else {
          setError(res.data.responseMessage);
        }
      })
      .catch((err) => {
        console.log(err);
      })
  };



  // Function to handle search changes
  // const handleSearchChange1 = (event, newValue) => {
  //   getVendorsByClientAndFreeText(newValue);
  // };
  const handleSearchChange1 = debounce((event, newValue) => {
    getVendorsByClientAndFreeText(newValue);
  }, 1000);

  // Effect to load initial vendors when the component mounts

  // useEffect(() => {
  //   // Check if vendors are already loaded, if not, fetch the initial vendors
  //   if (clientIDs) {
  //     getVendorsByClientAndFreeText('');
  //   }
  // }, [clientIDs]);

  const handleChange1 = (event) => {

    setVendorID(event?.key)
    setSelectedVendor(event)

  }
  const [clientdata, setClientdata] = React.useState()
  const [vendordata, setVendorldata] = React.useState()
  const SetVendorandClient = () => {

    setEmailtemplateLists(null);
    setCurrentPage(1);
    setSearchapi(false)
    setClientdata(clientID)
    setVendorldata(vendorID)
    setOpen(false);
    setSpinner(true);

  }
  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const handleSearchChange = (event) => {
    const { name, value } = event.target;
    setFieldData((prevData) => ({ ...prevData, [name]: value }));
  };
  const [selectedVendor, setSelectedVendor] = useState(null);
  const ClearField = () => {
    // setEmailtemplateLists([])
    setVendor([])
    setSelectValue1("")
    setVendorID("")
    setVendor([]); // Reset the vendor state to an empty array
    setSelectedVendor({ key: '', value: '' });


    setClientID("")
    setVendorldata(null)
    setClientdata(null)
    // setEmailtemplateLists(null)
  }
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const employeesPerPage = 10;
  const indexOfLastEmployee = currentPage * employeesPerPage;
  const indexOfFirstEmployee = indexOfLastEmployee - employeesPerPage;
  // Handle "Go to page" button click
  const [goToPage, setGoToPage] = useState(currentPage); // Initialize the input field with the current page
  // Handle "Go to page" input change


  // const handleGoToPageChange = (event) => {
  //   const value = event.target.value.trim(); // Trim any leading/trailing spaces
  //   // Check if the input is empty or non-numeric
  //   if (value === '' || isNaN(value)) {
  //     setGoToPage(''); // Clear the input field
  //     setCurrentPage(1); // Reset to the first page
  //     return;
  //   }
  //   let parsedValue = Number(value);
  //   // Validate input value
  //   if (parsedValue < 1) {
  //     parsedValue = 1; // Set minimum value to 1
  //   } else if (parsedValue > Math.ceil(totalEmployees / employeesPerPage)) {
  //     parsedValue = Math.ceil(totalEmployees / employeesPerPage); // Set maximum value to the total number of pages
  //   }
  //   setGoToPage(parsedValue);
  //   setCurrentPage(parsedValue); // Automatically update the current page
  // };


  // Handle "Go to page" button click
  // const handleGoToPageClick = () => {
  //   if (goToPage >= 1 && goToPage <= Math.ceil(totalEmployees / employeesPerPage)) {
  //     setCurrentPage(goToPage);
  //   }
  // };
  const [closeCollapse, setCloseCollapse] = useState(false);
  // Handle page change
  const handlePageChange = (event, page) => {
    const isLetter = /^[a-z]$/i.test(event)
    setCurrentPage(event);
    setGoToPage(event); // Update the input field value when clicking on a pagination number
    setSpinner(!spinner);
  };
  const [totalEmployees1, setTotalEmployees1] = useState(0);
  const [currentPage1, setCurrentPage1] = useState(1);
  const employeesPerPage1 = 10;
  const indexOfLastEmployee1 = currentPage1 * employeesPerPage1;
  const indexOfFirstEmployee1 = indexOfLastEmployee1 - employeesPerPage1;

  const [goToPage1, setGoToPage1] = useState(currentPage1); 
 
  const handleGoToPageChange1 = (event) => {
    setCloseCollapse(false)
    const value = event.target.value.trim(); // Trim any leading/trailing spaces
    // Check if the input is empty or non-numeric
    if (value === '' || isNaN(value)) {
      setGoToPage1(''); // Clear the input field
      setCurrentPage(1); // Reset to the first page
      return;
    }
    let parsedValue = Number(value);
    // Validate input value
    if (parsedValue < 1) {
      parsedValue = 1; // Set minimum value to 1
    } else if (parsedValue > Math.ceil(totalEmployees1 / employeesPerPage1)) {
      parsedValue = Math.ceil(totalEmployees1 / employeesPerPage1); // Set maximum value to the total number of pages
    }
    setGoToPage1(parsedValue);
    setCurrentPage1(parsedValue); // Automatically update the current page
  };
  const handlePageChange1 = (event, page) => {
    setCloseCollapse(false)
    setCurrentPage1(page);
    setGoToPage1(page); // Update the input field value when clicking on a pagination number
    setSpinner(!spinner);
  };
  const [spinner, setSpinner] = React.useState(false);
  const [trueset, setTrueset] = React.useState(false);
  const SpinnerClose = () => {
    setSpinner(false);
  };

  // const { data: res } = useFetch(
  //   "Employee/GetVendorEmployeeQuizList?VendorId=" + vendordata + "&clientId=" + clientdata + "&pageNumber=" + currentPage + "&size=10", false, false, refresh
  // );
  // useEffect(() => {
  //   setEmailtemplateLists(null);

  //   if (vendordata == null || clientdata == null) {
  //     setEmailtemplateLists(resp?.data);
  //     setSpinner(true);
  //     setTimeout(() => {
  //       setSpinner(false);
  //     }, 5000);
  //     setTrueset(true)

  //   }
  //   else {
  //     try {
  //       if (res?.data) {
  //         SetIstrue(false);
  //         setEmailtemplateLists(res?.data.employees);
  //         setTotalEmployees(res?.data?.employeescount);
  //         setCount(res?.data?.employeescount);
  //         setSpinner(false);
  //       }
  //       if (res?.data.employees) {
  //         handleClearFields();
  //       }
  //     } finally {
  //       setSpinner(false);
  //     }
  //   }
  // }, [res, refresh]);
  useEffect(() => {
    const isValid = (value) => value !== undefined && value !== "" && value !== null;
  
    if (isValid(vendordata) || isValid(clientdata)) {
      handleClearFields();
      axios.get(`Employee/GetVendorEmployeeQuizList?VendorId=${vendordata}&clientId=${clientdata}&pageNumber=${currentPage}&size=10`)
        .then((res) => {
          SetIstrue(false);
          setEmailtemplateLists(res?.data.data.employees);
          setTotalEmployees(res?.data.data?.employeescount);
          setCount(res?.data?.employeescount);
          setSpinner(false);
        });
    }
  }, [vendordata, clientdata, currentPage, refresh]);
  

  const [download, setDownload] = useState([]);

  useEffect(() => {
    if (clientdata !== undefined && vendordata !== undefined) {
      axios.get("Employee/DownloadEmployeeTrainingSummary?clientId=" + clientdata + "&vendorId=" + vendordata
      ).then((resp) => {
        if (clientdata == undefined && vendordata == undefined) {
          setDownload([]);
        } else {
          setDownload(resp?.data?.data);
        }

      })
    }
  }, [clientdata, vendordata]);

  const buSites = download?.map((row) => {
    return {
      empName: row?.empName,
      templateName: row?.templateName,
      quizResult: row?.quizResult,
      quizDateStart: row?.quizDateStart ? GetfVDateFormate(row?.quizDateStart, "") : "",
      vendor: row?.vendor,
      client: row?.client,
      moodleUserID: row?.moodleUserID,
    };
  });
  const headers = [
    { label: "Client Name", key: "client" },
    { label: "Vendor Name", key: "vendor" },
    { label: "Employee Name", key: "empName" },
    { label: "Course Name", key: "templateName" },
    { label: "Status", key: "quizResult" },
    { label: "Last Taken On", key: "quizDateStart" },
  ]


  const csvLink = {
    filename: "Training Summary.csv",
    headers: headers,
    data: buSites,
  };

  const ITEM_HEIGHT = 50;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 5 + ITEM_PADDING_TOP,
        width: 200,
      },
    },
  };

  const list = (anchor) => (

    <Box
      sx={{ width: anchor === 'right' ? 350 : 350, padding: "3px" }}
      role="presentation"
    >

      <Box sx={{ minWidth: 120 }}>
        <div style={{ float: "right", padding: "10px", color: "#999" }}> <ClearIcon sx={{ cursor: "pointer" }} onClick={handleDrawerClose} /></div>
        <br />
        <FormControl sx={{ m: 1, width: 320 }}>
          <span style={{ marginleft: "2px" }}>Client </span>
          <Select
            labelId="demo-multiple-name-label"
            id="demo-multiple-name"
            {...register("client")}
            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
              fontFamily: "Arial, FontAwesome"
            }}
            size="small"
            onChange={(e) => changeClients(e.target.value)}
            input={<OutlinedInput label="Select Client" value={selectValue1} />}
            MenuProps={MenuProps}
          >
            {client?.map((item, index) => (
              <MenuItem key={index} value={item.value}>
                {item.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <br />
        {/* <FormControl sx={{ m: 1, width: 320 }}>
          <span style={{ marginleft: "5px" }}>Vendor </span>
          <Autocomplete
            getOptionLabel={(vendor) => `${vendor.value}`}
            value={selectedVendor}
            options={vendor}
            size="small"
            onChange={(event, value) => handleChange1(value)}
            renderInput={(params) => (
              <TextField {...params} variant="outlined" fullWidth onChange={Getvendors} />
            )}
          />
        </FormControl> */}
        <FormControl sx={{ m: 1, width: 320 }}>
          <span style={{ marginLeft: '5px' }}>Vendor </span>
          <Autocomplete
            freeSolo
            getOptionLabel={(vendor) => `${vendor.value}`}
            value={selectedVendor}
            options={vendor.slice(0, 30)}
            size="small"
            onChange={(event, value) => handleChange1(value)}
            onInputChange={handleSearchChange1}
            renderInput={(params) => (
              <TextField {...params} placeholder="Search vendor" variant="outlined" fullWidth />
            )}
          />
        </FormControl>
        <Box sx={{ flexGrow: 1, display: "flex" }} />
        <Divider />
        <Box sx={{ marginTop: "auto" }}> <div className="login-help__buttonContainer">
          <Button variant="contained" onClick={ClearField} sx={{
            "& legend": { display: "none" },
            "& fieldset": { top: 0 },
            fontFamily: "Arial, FontAwesome"
          }} className="login-help-button-cancel">
            clear
          </Button>
          {/* {!vendorID || selectValue1 ==""? (<Tooltip title="Both Client and Vendor fields are mandatory" followCursor>
            <span>
              <Button
                variant="contained"
                className="login-button-request"
                disabled={!vendorID}
              >
                Save
              </Button>
            </span>
          </Tooltip>) : (<Button
            variant="contained"
            className="login-button-request"
            onClick={SetVendorandClient}
            disabled={!vendorID}
          >
            Save
          </Button>)} */}
          <Button
            variant="contained"
            className="login-button-request"
            onClick={SetVendorandClient}

          >
            Save
          </Button>
        </div></Box>
      </Box>
    </Box>
  );
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };


  const navigate = useNavigate();

  const [age, setAge] = React.useState('');
  const handleChange = (event) => {
    setAge(event?.target?.value);
  };
  const [fieldData, setFieldData] = useState({
    firstname: '',
    lastname: '',
    email: ''
  });
  const handleClearFields = () => {
    setFieldData({
      firstname: '',
      lastname: '',
      email: ''
    });
    setFirstnamesearch(undefined);
    setLastsearch(undefined);
    setEmailsearch(undefined);
  };
  const [firstnamesearch, setFirstnamesearch] = React.useState('');
  const [lastsearch, setLastsearch] = React.useState('');
  const [emailsearch, setEmailsearch] = React.useState('');
  const [SearchApi, setSearchapi] = React.useState(false);
  const handleKeyDown = (event, fieldName) => {
    if (event.key === 'Enter') {
      const { firstname, lastname, email } = fieldData;
      const data = `Field 1: ${firstname}\nField 2: ${lastname}\nField 3: ${email}`;
      ClearField();
      setCurrentPage1(1)
      setGoToPage1(1)
      setFirstnamesearch(fieldData.firstname)
      setLastsearch(fieldData.lastname)
      setEmailsearch(fieldData.email)
      setSpinner(!spinner);
      setSearchapi(true)
    }
  };


  // const { data: resp } = useFetch(
  //   "Employee/GetEmployeesByName?firstname=" + firstnamesearch + "&lastname=" + lastsearch + "&username=" + emailsearch + "&pageNumber=" + goToPage1 + "&size=10", false, false, refresh
  // );
  // useEffect(() => {
  //   setEmailtemplateLists(null);

  //   if (firstnamesearch == undefined || lastsearch == undefined || emailsearch == undefined) {
  //     setEmailtemplateLists(res?.data.employees);
  //     setSpinner(true);
  //     setTimeout(() => {
  //       setSpinner(false);
  //     }, 5000);
  //     setTrueset(true);
  //   } else {
  //     try {
  //       if (resp?.data) {
  //         setCloseCollapse(true);
  //         SetIstrue(true);
  //         setEmailtemplateLists(resp?.data);
  //         setSpinner(false);
  //         setTotalEmployees1(resp?.count);
  //       }
  //     } finally {
  //       setSpinner(false);
  //     }
  //   }
  // }, [resp, refresh]);




  useEffect(() => {
    const isSearchValid = (str) => str !== undefined && str !== "";
  
    if (isSearchValid(firstnamesearch) || isSearchValid(lastsearch) || isSearchValid(emailsearch)) {
      ClearField();
      axios.get(`Employee/GetEmployeesByName?firstname=${firstnamesearch}&lastname=${lastsearch}&username=${emailsearch}&pageNumber=${goToPage1}&size=10`)
        .then((resp) => {
          setCloseCollapse(true);
          SetIstrue(true);
          setEmailtemplateLists(resp?.data.data);
          setSpinner(false);
          setTotalEmployees1(resp?.data.count);
        });
    }
  }, [firstnamesearch, lastsearch, emailsearch, goToPage1, refresh]);
  




  return (
    <>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={spinner}
        onClick={SpinnerClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ padding: "20px" }}>
        <span style={{ fontSize: "28px", fontWeight: "600", color: "#101828" }}>
          Training
        </span>
        {buSites?.length > 0 ? (
          <CSVLink variant="contained" style={{ float: "right" }} {...csvLink}>
            <Button variant="contained" size="medium" onClick={() => setTrueset(true)}>
              <SaveAltIcon sx={{ marginRight: "5px" }} /> Download Employee Summary
            </Button>
          </CSVLink>
        ) : (
          <p></p>
        )}
        <Box sx={{ backgroundColor: "#fff", padding: "10px" }}>
          <Box>
            <Grid container>
              <Grid item xs={12} md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <span
                      style={{ fontSize: "18px", fontWeight: "500", color: "#3E4A62", }}
                    >
                      Employees List
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} md={2}>
                <Button variant="contained" size="medium" hidden={true}>
                  <SaveAltIcon sx={{ marginRight: "5px" }} />Upload Employees
                </Button>
              </Grid>
              <Grid item xs={12} md={1}>
                <Button hidden={true} variant="contained" size="medium" sx={{ padding: "13px" }} onClick={() => navigate("/AddEmployee")}>
                  +  Add New
                </Button>
              </Grid>
            </Grid>
          </Box>
          <hr sx={{ backgroundColor: "#E4E7EC;", height: "1px" }} />
          <div>
            <Box>
              <Grid container>
                <Grid item xs={12} md={11}>
                  <Grid container spacing={2}>
                    <Grid item xs={12} md={2}>
                      <TextField
                        placeholder='First name'
                        name="firstname"
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          fontFamily: "Arial, FontAwesome"
                        }}
                        value={fieldData.firstname}
                        onKeyDown={(event) => handleKeyDown(event, 'firstname')}
                        onChange={handleSearchChange}
                        variant="outlined"
                        size="small"

                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        placeholder='Last name'
                        name="lastname"
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          fontFamily: "Arial, FontAwesome"
                        }}
                        value={fieldData.lastname}
                        onKeyDown={(event) => handleKeyDown(event, 'lastname')}
                        onChange={handleSearchChange}
                        variant="outlined"
                        size="small"

                      />
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <TextField
                        name="email"
                        placeholder='Email'
                        sx={{
                          "& legend": { display: "none" },
                          "& fieldset": { top: 0 },
                          fontFamily: "Arial, FontAwesome"
                        }}
                        value={fieldData.email}
                        onKeyDown={(event) => handleKeyDown(event, 'email')}
                        onChange={handleSearchChange}
                        variant="outlined"
                        size="small"

                      />
                    </Grid>
                    {/* <button onClick={handleClearFields}>Clear Fields</button> */}
                  </Grid>
                </Grid>
                <Grid item xs={12} md={1}>
                  <div>
                    {['right'].map((anchor) => (
                      <React.Fragment key={anchor}>
                        <Button sx={{ float: "right", padding: "7px" }} onClick={handleDrawerOpen}> <FilterAltIcon /> filter</Button>
                        <SwipeableDrawer
                          anchor="right"
                          open={open}
                        >
                          {list(anchor)}
                        </SwipeableDrawer>
                      </React.Fragment>
                    ))}
                  </div>
                </Grid>
              </Grid>
            </Box>
          </div>
          <TableContainer component={Paper} sx={{ marginTop: "10px" }}>
            <Table aria-label="collapsible table">
              <TableHead>
                <TableRow>
                  <StyledTableCell />
                  <StyledTableCell align="left">Vendor</StyledTableCell>
                  {/* <StyledTableCell align="left" sx={{display:istrue?"none":""}}>Status</StyledTableCell> */}
                  <StyledTableCell align="left">Employee Name</StyledTableCell>
                  <StyledTableCell align="left">Email</StyledTableCell>
                  <StyledTableCell align="left">Title</StyledTableCell>
                  <StyledTableCell align="left">ID Type</StyledTableCell>
                  <StyledTableCell align="left">
                    Last 4 Digits of ID
                  </StyledTableCell>
                  <StyledTableCell align="left">&nbsp;</StyledTableCell>
                  {/* <StyledTableCell align="left" sx={{display:istrue?"none":""}}>&nbsp;</StyledTableCell> */}
                  <StyledTableCell align="left">&nbsp;</StyledTableCell>
                  <StyledTableCell align="left">&nbsp;</StyledTableCell>
                  <StyledTableCell align="left">&nbsp;</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {EmailtemplateLists?.map((row, index) => (
                  <Row key={index} row={row} setTrue={istrue} closeCollapsed={closeCollapse} setSpinners={setSpinner} spinners={!spinner} setRefres={setRefresh} refres={refresh} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
           <div hidden={EmailtemplateLists?.length == 0}>
            {istrue == false ? (
              <div hidden={spinner || istrue==true} style={{ display: 'flex', alignItems: 'center', padding: '1rem' }}>

                <Paginator
                  hidden={EmailtemplateLists?.length == 0}
                  count={Math.ceil(totalEmployees / employeesPerPage)}
                  page={Number(currentPage)}
                  num={currentPage}
                  margin="18px 0px"
                  onChange={handlePageChange}
                />
              </div>) : (
              <div hidden={spinner} style={{ display: 'flex', alignItems: 'center', padding: '1rem' }}>
                <Pagination
                  count={Math.ceil(totalEmployees1 / employeesPerPage1)}
                  // page={currentPage1}
                  hidden={EmailtemplateLists?.length == 0}
                  page={currentPage1 === 0 ? 1 : currentPage1}
                  shape="rounded" color="primary"
                  onChange={handlePageChange1}
                />
                <div style={{ marginLeft: '1rem', display: 'flex', alignItems: 'center' }}>
                  <Typography variant="body2" style={{ marginRight: '0.5rem' }}>
                    Go to Page
                  </Typography>
                  <TextField id="outlined-basic" variant="outlined"
                    sx={{ width: "100px" }}
                    placeholder="Page"
                    size="small"
                    type="text"
                    value={goToPage1}
                    onChange={handleGoToPageChange1}
                    max={Math.ceil(totalEmployees1 / employeesPerPage1)}
                    inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
                  />
                </div>

              </div>)}
          </div> 
        </Box>
        <div hidden={spinner} style={{ display: EmailtemplateLists?.length > 0 ? "none" : "" }}> <Nodata /></div>
      </Box>
    </>
  );
}
